import type { RegistryType } from "@/schemas/digital-files/registry";
import { cn } from "@/utils/theme";
import {
  Avatar,
  AvatarFallback,
  Button,
  Icon,
} from "@elaniintc/goes-design-system";
import dayjs from "dayjs";
// import { useState } from "react";
import { Link } from "react-router";

interface RegistryRowCardProps {
  entityId?: string | null;
  data: RegistryType;
}

export const RegistryRowCard = ({ entityId, data }: RegistryRowCardProps) => {
  // const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <Link
        to={`/expedientes/entidad/${entityId}/detalle-registro/${data.id}`}
        className={cn(
          "flex justify-between bg-neutral-object-accent-silent border border-neutral-quiet w-full min-h-12 pl-3 pr-4 py-2",
          /* isOpen ? "rounded-t-lg" : "rounded-lg", */
          "rounded-lg",
        )}
      >
        {/* <div className="flex gap-2 min-w-0 flex-1"> */}
        <div className="flex gap-2 min-w-0 flex-1 justify-between items-center">
          {/* When added the resolution count, remove this div */}
          <div className="flex gap-2 w-full max-w-[95%]">
            <Avatar size="xs" shape="square" className="shrink-0">
              <AvatarFallback shape="square">
                <Icon type="fas" name="folder" className="text-action-quiet" />
              </AvatarFallback>
            </Avatar>
            <p className="leading-3xl text-body-loud font-semibold text-size-body-md truncate min-w-0">
              {data.name}
            </p>
          </div>
          {/* <Link
            to={`/expedientes/entidad/${entityId}/detalle-registro/${data.id}`}
            className="shrink-0"
          >
          </Link> */}
          <Button
            variant="ghost-blue"
            size="icon"
            aria-label="Opciones"
            className="shadow-none hover:shadow-neutral-xs"
            type="button"
            onClick={() => {}}
          >
            <Icon type="far" name="arrow-up-right-from-square" />
          </Button>
        </div>
        <div className="flex gap-3 md:gap-12 shrink-0">
          {/* <div className="gap-4 sm:flex hidden shrink-0">
            {
              <div className="flex items-center gap-1 text-body text-size-body-sm md:text-size-body shrink-0 whitespace-nowrap">
                <Icon
                  type="far"
                  name="file-contract"
                  className="text-size-body shrink-0"
                />
                <p className="whitespace-nowrap">
                  {data.request_count ?? 0} solicitudes
                </p>
              </div>
            }

            <div className="flex items-center gap-1 text-body text-size-body-sm md:text-size-body shrink-0 whitespace-nowrap">
              <Icon
                type="far"
                name="file-check"
                className="text-size-body shrink-0"
              />
              <p className="whitespace-nowrap">
                {data.resolution_count ?? 0} Resoluciones
              </p>
            </div>

            {data.associates && data.associates.length > 0 && (
              <div className="flex items-center gap-2 shrink-0 whitespace-nowrap">
                <div
                  className="flex relative h-7 shrink-0"
                  style={{
                    width:
                      Math.min(data?.associates?.length, 3) * 10 + 16 + "px",
                  }}
                >
                  {Array.from({
                    length: Math.min(data.associates?.length, 3),
                  }).map((_, index) => (
                    <Avatar
                      key={index}
                      size="xs"
                      shape="circle"
                      className="absolute top-0"
                      style={{
                        left: 12 * index + "px",
                      }}
                    >
                      <AvatarFallback className="bg-[#D8E6FD]" shape="circle">
                        {data?.associates
                          ? data.associates[index].applicant?.first_name
                              ?.charAt(0)
                              .toUpperCase()
                          : "S"}
                      </AvatarFallback>
                    </Avatar>
                  ))}
                </div>
                <p className="text-action hidden md:block whitespace-nowrap">
                  {data.associates.length === 1
                    ? `${data.associates[0].applicant?.first_name || ""} ${
                        data.associates[0].applicant?.last_name || ""
                      }`
                    : `+${data.associates.length} Solicitantes`}
                </p>
              </div>
            )}
          </div> */}
          {/* <Button
            disabled={data.resolution_count === 0}
            variant="ghost"
            size="icon"
            aria-label="Agregar"
            className="shadow-none hover:shadow-neutral-xs"
            onClick={() => setIsOpen(!isOpen)}
          >
            <Icon type="far" name={isOpen ? "minus" : "plus"} />
          </Button> */}
        </div>
      </Link>
      <ul
        className={cn(
          "border border-t-0 border-neutral-quiet rounded-b-lg grid overflow-hidden transition-all duration-300 ease-in-out",
          // isOpen
          //   ? "grid-rows-[1fr] opacity-100"
          //   : "grid-rows-[0fr] opacity-0 border-transparent",
          "grid-rows-[0fr] opacity-0 border-transparent",
        )}
      >
        <div className="overflow-hidden">
          {data.resolutions?.map((t) => (
            <li
              key={t.id}
              className="px-4 py-2 flex flex-col sm:flex-row justify-between items-center border-neutral-quiet border-b last:border-b-0"
            >
              <div className=" flex gap-1 items-center justify-center text-center">
                <div className="flex flex-col text-center justify-center tablet:gap-2 tablet:flex-row sm:text-left sm:justify-start">
                  <p className="text-body-loud truncate">Solicitud {t.code}</p>
                  <p className="text-body-quiet font-mono text-size-body capitalize truncate">
                    {dayjs(t.created_at).format("MMM DD, YYYY")}
                  </p>
                </div>
                <Icon
                  type="far"
                  name="arrow-right"
                  className="text-body-loud"
                />
                <div className="flex flex-col text-center justify-center tablet:gap-2 tablet:flex-row sm:text-left sm:justify-start">
                  {t.code ? (
                    <>
                      <p className="text-body-loud truncate">
                        Resolución {t.code}
                      </p>
                      <p className="text-body-quiet font-mono text-size-body capitalize truncate">
                        {t.resolution_date
                          ? dayjs(t.resolution_date).format("MMM DD, YYYY")
                          : ""}
                      </p>
                    </>
                  ) : (
                    <p className="text-body-quiet truncate">Sin Resolución</p>
                  )}
                </div>
              </div>
              {t.applicant && (
                <div
                  className={cn(
                    "flex items-center justify-center pt-2 sm:pt-0 gap-2 border-t border-neutral-quiet w-full",
                    "sm:border-none sm:justify-end",
                  )}
                >
                  <p className="text-body-quiet">Solicitante</p>
                  {t.applicant && (
                    <>
                      <Avatar size="xs" shape="circle">
                        <AvatarFallback className="bg-[#D8E6FD]" shape="circle">
                          {t.applicant.name?.charAt(0).toUpperCase()}
                        </AvatarFallback>
                      </Avatar>
                      <p className="text-action truncate">{t.applicant.name}</p>
                    </>
                  )}
                </div>
              )}
            </li>
          ))}
        </div>
      </ul>
    </div>
  );
};
